<template>
  <div
    class="back-button"
    :class="{
      'back-button bottom': bottom
    }"
    @click="onBack"
  >
    <img alt="back" src="../assets/images/back.png" class="back-button-image" />
    Back
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'BackButton',
  props: {
    bottom: Boolean
  },
  computed: {
    ...mapGetters({
      userGroups: 'auth/getUserGroups',
      callFlow: 'onboarding/getSelectedCallFlow',
      textFlow: 'onboarding/getSelectedTextFlow'
    }),
    groups() {
      return this.userGroups.filter((group) => group.isCreated === true);
    }
  },
  methods: {
    onBack() {
      const { routes } = this.$router.options;
      const { path, query } = this.$route;
      if (!this.$route.meta.requiresAuth || this.$route.meta.step < 3) {
        const routeIndex = routes.findIndex((route) => route.path === this.$route.path);
        if (path === '/checkout') {
          this.$router.push('/numbers');
        } else if (path === '/numbers') {
          this.$router.push('/');
        } else if (path === '/numbers/select') {
          this.$router.push(`/numbers/search?type=${query.type === 'tollfree_random' ? 'tollfree' : query.type}`);
        } else if (path === '/numbers/porting') {
          this.$router.push(`/numbers/search?type=porting`);
        } else if (routeIndex > 1) {
          this.$router.push(routes[routeIndex - 1].path);
        }
      } else if (this.$route.meta.step === 3) {
        if (this.groups.length === 0) {
          this.$router.push('/invite-team');
        } else {
          this.$router.push('/create-groups');
        }
      } else if (this.$route.meta.step === 4) {
        this.$router.push('/call-flow');
      } else {
        const baseRoute = '/text-flow/';
        const type = this.textFlow.type;
        this.$router.push(baseRoute + type);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.back-button {
  width: 58px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.1px;
  color: $colorText;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;

  &.bottom {
    align-self: center;
    margin-top: 23px;
  }

  .back-button-image {
    width: 8px;
    height: 13.5px;
    margin-right: 7px;
  }
}
</style>
